export const getDisplayNameFromToken = (decodedToken = {}) => (
  decodedToken?.given_name
  || decodedToken?.name
  || decodedToken?.['custom:cocoName']
  || decodedToken?.['custom:name']
  || null
);
